export default __webpack_public_path__ + "static/media/clock.859ad258.png";